import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class CleaningNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the deleteShopifyCartLineItems global action. */
    this.deleteShopifyCartLineItems = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deleteShopifyCartLineItems",
      operationName: "deleteShopifyCartLineItems",
      operationReturnType: "CleaningDeleteShopifyCartLineItems",
      namespace: "cleaning",
      variables: {}
    });
    /** Executes the deleteShopifyCarts global action. */
    this.deleteShopifyCarts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deleteShopifyCarts",
      operationName: "deleteShopifyCarts",
      operationReturnType: "CleaningDeleteShopifyCarts",
      namespace: "cleaning",
      variables: {}
    });
    /** Executes the deleteShopifyCheckoutLineItems global action. */
    this.deleteShopifyCheckoutLineItems = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deleteShopifyCheckoutLineItems",
      operationName: "deleteShopifyCheckoutLineItems",
      operationReturnType: "CleaningDeleteShopifyCheckoutLineItems",
      namespace: "cleaning",
      variables: {}
    });
    /** Executes the deleteShopifyCheckouts global action. */
    this.deleteShopifyCheckouts = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "deleteShopifyCheckouts",
      operationName: "deleteShopifyCheckouts",
      operationReturnType: "CleaningDeleteShopifyCheckouts",
      namespace: "cleaning",
      variables: {}
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "cleaning",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  CleaningNamespace
};
//# sourceMappingURL=cleaning.js.map
